import { ResponseError } from '@infrastructure/axios/error';
import AppDispatcher from '@app/events/app-commander';

export default function onNetworkError() {
  return function (error: ResponseError) {
    AppDispatcher.showToast({ mode: 'error', message: error.code });
  };
}
